export default __webpack_public_path__ + "static/media/paused-sub-bg@2x.1548cebe.png";